import { get } from 'lodash';
import { saveAs } from 'file-saver';
import { createAPIError, defaultAPIError } from './errors';
import {
  createAPIService,
  createFileUploadService,
  createFileVaultService,
} from './api.service';

const service = createAPIService('/document/api/');
const fileUploadService = createFileUploadService();
const fileVaultService = createFileVaultService();

export const uploadFile = async formData => {
  const response = await fileUploadService.post(
    '/storage/api/public/files',
    formData
  );
  return response.data;
};

export const moveFileToVault = async data => {
  const response = await fileVaultService.post(
    '/payandsubmit/storage/files/vault',
    data
  );
  return response.data;
};

service.downloadSurvey = async v => {
  const { surveyTemplateId, ...rest } = v;

  try {
    const response = await service.get(surveyTemplateId, {
      responseType: 'blob',
      params: rest,
    });

    const filename = (response.headers['content-disposition'] || '').match(
      /filename="(.*)"/
    );

    const saveAsFilename =
      (filename && filename.length && filename[1]) || 'survey.pdf';

    if (navigator.msSaveBlob) {
      navigator.msSaveBlob(response.data, saveAsFilename);
    } else {
      saveAs(response.data, saveAsFilename);
    }
    return true;
  } catch (err) {
    switch (get(err, 'response.status', err.code)) {
      case 404:
      case 403:
        throw createAPIError(err);
      default:
        throw defaultAPIError(err);
    }
  }
};

export default service;
